import { render, staticRenderFns } from "./HygienistsDouble.vue?vue&type=template&id=2af9e0da&scoped=true"
import script from "./HygienistsDouble.vue?vue&type=script&lang=js"
export * from "./HygienistsDouble.vue?vue&type=script&lang=js"
import style0 from "./HygienistsDouble.vue?vue&type=style&index=0&id=2af9e0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af9e0da",
  null
  
)

export default component.exports